var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dd-info-container" }, [
    _c(
      "div",
      { staticClass: "dd-top-section", class: { "in-slider": _vm.inSlider } },
      [
        _c(
          "div",
          {
            staticClass: "dd-bear-img-container",
            class: { "in-slider": _vm.inSlider }
          },
          [
            _c("img", {
              staticClass: "dd-bear-img",
              class: { "in-slider": _vm.inSlider },
              attrs: {
                src: "/Content/responsive/images/bear-circle.svg",
                alt: ""
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dd-top-header",
                class: { "in-slider": _vm.inSlider }
              },
              [
                _vm._v("DISCOUNT DEN"),
                _c(
                  "span",
                  { staticClass: "sm", class: { "in-slider": _vm.inSlider } },
                  [_vm._v("®")]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "text-container",
            class: { "in-slider": _vm.inSlider }
          },
          [
            _c(
              "div",
              {
                staticClass: "dd-top-generic",
                class: { "in-slider": _vm.inSlider }
              },
              [
                _vm._v(
                  "With a DISCOUNT DEN membership you will have exclusive access to Frontier's lowest fares, guaranteed."
                )
              ]
            ),
            _vm._v(" "),
            this.discountAmount === "$0.00"
              ? _c(
                  "div",
                  { staticClass: "dd-top-cost" },
                  [
                    _vm._v(
                      "Annual membership costs " +
                        _vm._s(_vm.signupFeeAmount) +
                        " for one full year of savings. New members pay " +
                        _vm._s(_vm.totalAmount) +
                        " their first year (" +
                        _vm._s(_vm.signupFeeAmount) +
                        " + " +
                        _vm._s(_vm.enrollmentFeeAmount) +
                        " enrollment fee).\n                 "
                    ),
                    _c(
                      "f9link",
                      {
                        staticClass: "learn-more",
                        attrs: {
                          href:
                            "https://www.flyfrontier.com/deals/discount-den/",
                          target: "_blank"
                        }
                      },
                      [_vm._v("Learn More")]
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "dd-top-cost" },
                  [
                    _vm._v(
                      "Annual membership costs " +
                        _vm._s(_vm.signupFeeAmount) +
                        " for one full year of savings, new members pay an additional enrollment fee.\n                 "
                    ),
                    _c(
                      "f9link",
                      {
                        staticClass: "learn-more",
                        attrs: {
                          href:
                            "https://www.flyfrontier.com/deals/discount-den/",
                          target: "_blank"
                        }
                      },
                      [_vm._v("Learn More")]
                    )
                  ],
                  1
                )
          ]
        ),
        _vm._v(" "),
        _vm.totalAmount === ""
          ? _c(
              "div",
              {
                staticClass: "dd-top-sub errorState",
                class: { "in-slider": _vm.inSlider }
              },
              [
                _vm._v(
                  "An error has occurred.  Please refresh the page and try again.  If the problem persists please contact our "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.flyfrontier.com/chat-with-us/",
                      target: "_blank"
                    }
                  },
                  [_vm._v("chat agents")]
                ),
                _vm._v(".")
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showLimitedTimeOffer,
                expression: "showLimitedTimeOffer"
              }
            ],
            staticClass: "limited-time-offer-container",
            class: { "in-slider": _vm.inSlider }
          },
          [
            _c("limited-Time-Offer", {
              attrs: {
                backgroundColor: "#006643",
                color: "#ffffff",
                signupFeeAmount: _vm.signupFeeAmount,
                enrollmentFeeAmount: _vm.enrollmentFeeAmount,
                discountedEnrollmentFeeAmount:
                  _vm.discountedEnrollmentFeeAmount,
                totalAmount: _vm.totalAmount
              }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.inSlider,
          expression: "!inSlider"
        }
      ],
      staticClass: "greyBackground",
      class: { "in-slider": _vm.inSlider }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dd-benefits-details-container",
        class: { "in-slider": _vm.inSlider }
      },
      [
        _c(
          "div",
          {
            staticClass: "low-fares-container",
            class: { "in-slider": _vm.inSlider }
          },
          [
            _c("img", {
              class: { "in-slider": _vm.inSlider },
              attrs: {
                src: "/Content/responsive/images/savings_icon.svg",
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "heading lowest-fares" }, [
              _vm._v("Lowest Fare Guaranteed")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "sub-heading lowest-fares" }, [
              _vm._v("Exclusive access to the lowest fares")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "kff-container",
            class: { "in-slider": _vm.inSlider }
          },
          [
            _c("img", {
              class: { "in-slider": _vm.inSlider },
              attrs: {
                src: "/Content/responsive/images/backpack phone.svg",
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "heading kff" }, [
              _vm._v("Kids Fly Free"),
              _c(
                "span",
                { staticClass: "sm", class: { "in-slider": _vm.inSlider } },
                [_vm._v("℠")]
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "sub-heading kff" }, [
              _vm._v("Kids Fly Free on select dates & flights")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "exclusive-container",
            class: { "in-slider": _vm.inSlider }
          },
          [
            _c("img", {
              class: { "in-slider": _vm.inSlider },
              attrs: { src: "/Content/responsive/images/phone.svg", alt: "" }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "heading exclusive" }, [
              _vm._v("Exclusive Deals")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "sub-heading exclusive" }, [
              _vm._v("Get our lowest fare and exclusive promotions")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "share-container",
            class: { "in-slider": _vm.inSlider }
          },
          [
            _c("img", {
              class: { "in-slider": _vm.inSlider },
              attrs: {
                src: "/Content/responsive/images/suitcases.svg",
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "heading" }, [
              _vm._v("Share the Savings")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "sub-heading" }, [
              _vm._v("Book DISCOUNT DEN fares for up to 9 people")
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-615395bc", { render: render, staticRenderFns: staticRenderFns })
  }
}